module.exports = __webpack_public_path__ + "img/meter-droplet.17397e90.svg";